export default "__VITE_ASSET__4ec800aa__"